import { render } from "./DesignScreen.vue?vue&type=template&id=444482b0"
import script from "./DesignScreen.vue?vue&type=script&lang=js"
export * from "./DesignScreen.vue?vue&type=script&lang=js"

import "./DesignScreen.vue?vue&type=style&index=0&id=444482b0&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__